import React, { useEffect, useState } from "react";

//import Scss
import "./assets/scss/themes.scss";

//imoprt Route
import Route from "./Routes";
import "./App.css";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// Fake Backend
import fakeBackend from "./helpers/AuthType/fakeBackend";

// Activating fake backend
fakeBackend();
import { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { REFRESH_INTERVAL, refreshToken } from "./utilis/authUtilis";
import _BaseAPIService from "./services/_BaseAPIService";

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// // init firebase backend
// initFirebaseBackend(firebaseConfig);
import "./utilis/arrayPrototypes";
import { LoadingProvider } from "./Components/Common/LoadingContext/page/LoadingContext";
import IdleVideoAd from "./Components/IdleVideoAd/IdleVideoAd";
import DeviceInspector from "./modalinspect";

function App() {
  const navigate = useNavigate();

  const appType = window.APP_CONFIG?.appType;
  console.log("🚀 ~ App ~ appType:", appType);
  useEffect(() => {
    const currentPath = window.location.pathname;

    // Only redirect to /touchy if on root or if not already on a specific route
    // This allows /order-summary and other routes to work properly
    if (
      appType === "TouchBased" &&
      (currentPath === "/" || currentPath === "")
    ) {
      navigate("/touchy", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const isDesktopApp = !!window.chrome?.webview;
    const isLocalDev = process.env.NODE_ENV === "development";

    const saveDeviceContext = ({ IpAddress, MacId, orgDevice }) => {
      if (!orgDevice) {
        console.warn("No orgDevice received");
        return;
      }

      console.log("Device context received:", orgDevice);

      localStorage.setItem("IpAddress", IpAddress);
      localStorage.setItem("MacId", MacId);
      localStorage.setItem("deviceContext", JSON.stringify(orgDevice));
      localStorage.setItem("deviceCode", orgDevice.deviceCode);
      localStorage.setItem("orgcode", orgDevice.orgCode);
      localStorage.setItem("deviceName", orgDevice.deviceName);
      localStorage.setItem("organizationId", orgDevice.organizationId);
      localStorage.setItem("terminal", orgDevice.terminal);
    };

    if (isDesktopApp) {
      const handler = (event) => {
        saveDeviceContext(event.data);
      };

      window.chrome.webview.addEventListener("message", handler);


      return () => {
        window.chrome.webview.removeEventListener("message", handler);
      };

    }

    if (isLocalDev) {
      const mockDeviceContext = {
        deviceCode: "LOCAL-DANFE-MAN-TOUCH",
        orgCode: "DAN5434",
        deviceName: "Danfe Touch (Local)",
        organizationId: 1,
        terminal: "terminal1",
        showHeartBeatWindow: false,
      };

      saveDeviceContext({ 
        IpAddress: "192.168.1.192", 
        MacId: "145D346BDE3F", 
        orgDevice: mockDeviceContext 
      });
    }
  }, []);

  // useEffect(() => {
  //   const isDesktopApp = !!window.chrome?.webview;
  //   const isLocalDev = process.env.NODE_ENV === "development";

  //   const saveDeviceContext = (data) => {
  //     console.log("Device context received:", data);

  //     localStorage.setItem("deviceContext", JSON.stringify(data));
  //     localStorage.setItem("deviceCode", data.deviceCode);
  //     localStorage.setItem("orgcode", data.orgCode);
  //   };

  //   if (isDesktopApp) {
  //     const handler = (event) => {
  //       saveDeviceContext(event.data);
  //     };

  //     window.chrome.webview.addEventListener("message", handler);

  //     return () => {
  //       window.chrome.webview.removeEventListener("message", handler);
  //     };
  //   }

  //   if (isLocalDev) {
  //     const mockDeviceContext = {
  //       deviceCode: "LOCAL-DANFE-TOUCH",
  //       organizationId: 1,
  //       orgCode: "DAN5434",
  //       deviceName: "Danfe-Touch (Local)",
  //       showHeartBeatWindow: false,
  //       terminal: "terminal1",
  //     };

  //     saveDeviceContext(mockDeviceContext);
  //   }
  // }, []);

  // useEffect(() => {
  //   const userString = localStorage.getItem("user");
  //   if (userString) {
  //     _BaseAPIService.startRefreshTokenPolling();
  //   }
  // }, []);
  // const navigate = useNavigate();
  // useEffect(() => {
  //   _BaseAPIService.setupInterceptors(navigate);
  // }, [navigate]);
  return (
    <React.Fragment>
            <DeviceInspector />
      {/* {appType === "TouchBased" && <IdleVideoAd idleTime={70000} />} */}
      <LoadingProvider>
        <Route />
        <Toaster />
      </LoadingProvider>
    </React.Fragment>
  );
}

export default App;
